import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAlertsFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    />
    <path
      fill="url(#AlertsFull_svg__a)"
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
      opacity={0.35}
    />
    <path
      fill="url(#AlertsFull_svg__b)"
      d="M8.616 18.35a.779.779 0 0 1 1.557 0v4.671a.779.779 0 0 1-1.557 0z"
    />
    <path
      fill="url(#AlertsFull_svg__c)"
      d="M8.616 9.8c0-.838.543-1.58 1.343-1.835a6.74 6.74 0 0 1 4.782.266l.846.376a7.08 7.08 0 0 0 4.576.405 2.022 2.022 0 0 1 2.508 1.963v3.592a2.536 2.536 0 0 1-2.226 2.518l-.501.062a7.2 7.2 0 0 1-4.07-.69l-.77-.382a5.3 5.3 0 0 0-4.39-.14 1.515 1.515 0 0 1-2.098-1.398z"
    />
    <defs>
      <linearGradient
        id="AlertsFull_svg__a"
        x1={24.374}
        x2={-13.126}
        y1={22.031}
        y2={21.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F19325" />
        <stop offset={1} stopColor="#FAD2A4" />
      </linearGradient>
      <linearGradient
        id="AlertsFull_svg__b"
        x1={20.036}
        x2={2.465}
        y1={19.51}
        y2={19.191}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F19325" />
        <stop offset={1} stopColor="#FAD2A4" />
      </linearGradient>
      <linearGradient
        id="AlertsFull_svg__c"
        x1={20.036}
        x2={2.465}
        y1={19.51}
        y2={19.191}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F19325" />
        <stop offset={1} stopColor="#FAD2A4" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAlertsFull;
